import CategoriesManagement from "../../../components/portal/categories/CategoriesManagement";

const CompanyCategoryPage = () => {
  return (
    <>
      <CategoriesManagement type={"company"} />
    </>
  );
};

export default CompanyCategoryPage;
